import React from "react";

const Volunteer = () => {
  return <div>Volunteer</div>;
};

export default Volunteer;
